export const paymentReceipts = (payment) => {
  if (Array.isArray(payment?.receiptDocuments) && payment.receiptDocuments.length) {
    return payment.receiptDocuments.filter(Boolean);
  }
  if (payment?.receiptDocument) return [payment.receiptDocument];
  return [];
};

export const collectInvoiceReceipts = (data) => {
  const fromPayments = (Array.isArray(data?.payments) ? data.payments : []).flatMap(
    paymentReceipts
  );

  const base = fromPayments.length
    ? fromPayments
    : Array.isArray(data?.invoiceDocument)
    ? data.invoiceDocument
    : data?.invoiceDocument
    ? [data.invoiceDocument]
    : [];

  return [...new Set(base.filter(Boolean))];
};
